module.exports = __webpack_public_path__ + "static/media/cuny-white2018.11fe519b.png";